import api from "services/api";


export const createChat = async (chatData) => {
  try {
    const formData = new FormData();

    formData.append("sender_id", chatData.sender_id);
    formData.append("receiver_id", chatData.receiver_id);
    formData.append("chat_type", chatData.chat_type);

    if (chatData.message) formData.append("message", chatData.message);
    if (chatData.location) formData.append("location", chatData.location);

    if (chatData.images && chatData.images.length > 0) {
      chatData.images.forEach((img) => {
        formData.append("images", img);
      });
    }

    if (chatData.documents && chatData.documents.length > 0) {
      chatData.documents.forEach((doc) => {
        formData.append("documents", doc);
      });
    }

    const response = await api.post("chat-management/chats/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, error: "Failed to create chat" };
    }
  } catch (error) {
    console.error("Create Chat Error:", error.response?.data || error.message);
    return {
      success: false,
      error: error.response?.data?.detail || "Could not create chat",
    };
  }
};


export const getChatBetweenUsers = async (otherUserId) => {
  try {
    const response = await api.get(`/chat-management/chats/between/${otherUserId}`);

    if (response.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, error: "Unexpected server response" };
    }
  } catch (error) {
    console.error("Error getting chat between users:", error.response?.data || error.message);
    return {
      success: false,
      error: error.response?.data?.detail || "Failed to fetch chat",
    };
  }
};


export const getAllChats = async () => {
  try {
    const response = await api.get("/chat-management/chats/");

    if (response.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, error: "Unexpected server response" };
    }
  } catch (error) {
    console.error("Error getting all chats:", error.response?.data || error.message);
    return {
      success: false,
      error: error.response?.data?.detail || "Failed to fetch chats",
    };
  }
};


export const markChatAsRead = async (chatId) => {
  try {
    const response = await api.patch(`/chat-management/chats/${chatId}/read`);

    if (response.status === 200) {
      return { success: true, data: response.data.data };
    } else {
      return { success: false, error: "Unexpected server response" };
    }
  } catch (error) {
    console.error("Mark Chat As Read Error:", error.response?.data || error.message);
    return {
      success: false,
      error: error.response?.data?.detail || "Could not mark chat as read",
    };
  }
};